<template>
  <p-container>
    <p-row class="header" align-center>
      <p-button tertiary @click="$router.back()">
        <p-icon>
          keyboard_backspace
        </p-icon>
      </p-button>
      <h2>
        {{ $t('page.app.redebits.upload.title') }}
      </h2>
    </p-row>
    <p-row v-if="page.uploadDataSource.isLoading">
      <p-progress-linear :indeterminate="true" />
    </p-row>
    <p-request-alert v-else-if="page.uploadDataSource.error" v-model="page.uploadDataSource.error"></p-request-alert>
    <p-row v-else column>
      <p-col>
        <p-file-drop
          v-model="page.files"
          :label="$t('page.app.redebits.upload.upload.label')"
          :loading="page.uploadDataSource.isLoading"
          max="1"
          :single="true"
          accept="text/xml"
        ></p-file-drop>
      </p-col>
      <p-col justify-end>
        <p-button :disabled="page.files.length < 1 || page.uploadDataSource.isLoading " :loading="page.uploadDataSource.isLoading" class="mr-3" secondary @click="page.uploadFile()">
          <p-icon left>
            upload_file
          </p-icon>{{ $t('page.app.redebits.upload.action.label') }}
        </p-button>
      </p-col>
      <p-col v-if="page.uploadSuccess">
        <p-alert :value="page.uploadSuccess" type="success">
          {{ $t('page.app.redebits.upload.success') }}
        </p-alert>
      </p-col>
    </p-row>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';
  import UploadRedebitPage from './upload.vue.model';

  export default Vue.extend({
    auth: true,
    role: ['admin', 'hostadmin'],
    layout: 'layout-hostadmin',

    data: () => ({
      page: new UploadRedebitPage(),
    }),
  });

</script>
